export const SET_APPLICATION_PERIODS = 'SET_APPLICATION_PERIODS';
export const UPDATE_APPLICATION_PERIODS = 'UPDATE_APPLICATION_PERIODS';
export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_APPLICATION = 'SET_APPLICATION';
export const REFRESH_APPLICATION = 'REFRESH_APPLICATION';
export const SET_USER = 'SET_USER';
export const UPDATE_BASIC_INFO = 'UPDATE_BASIC_INFO';
export const SET_PASSCODE = 'SET_PASSCODE';

// Used for first time users while account is set up
export const SET_NEW_USER = 'SET_NEW_USER';

// Form Actions
export const SET_STEP = 'SET_STEP';

// Application Actions
export const TOGGLE_CONFIRMATION = 'TOGGLE_CONFIRMATION';
export const SET_APPLICATION_STATUS = 'SET_APPLICATION_STATUS';
export const TOGGLE_UPGRADE_OPTION = 'TOGGLE_UPGRADE_OPTION';
export const SET_UPGRADE_OPTION = 'SET_UPGRADE_OPTION';

// Education Information Actions
export const ADD_COURSE = 'ADD_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const REMOVE_COURSE = 'REMOVE_COURSE';
export const ADD_COLLEGE = 'ADD_COLLEGE';
export const UPDATE_COLLEGE = 'UPDATE_COLLEGE';
export const REMOVE_COLLEGE = 'REMOVE_COLLEGE';
export const UPDATE_EDUCATION_INFO = 'UPDATE_EDUCATION_INFO';

// Professional Information Actions
export const UPDATE_PROFESSIONAL_INFO = 'UPDATE_PROFESSIONAL_INFO';
export const ADD_DEGREE = 'ADD_DEGREE';
export const REMOVE_DEGREE = 'REMOVE_DEGREE';
export const UPDATE_DEGREE = 'UPDATE_DEGREE';
export const ADD_LICENSE = 'ADD_LICENSE';
export const REMOVE_LICENSE = 'REMOVE_LICENSE';
export const UPDATE_LICENSE = 'UPDATE_LICENSE';
export const ADD_CERTIFICATE = 'ADD_CERTIFICATE';
export const REMOVE_CERTIFICATE = 'REMOVE_CERTIFICATE';
export const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE';

// Other Information Actions
export const UPDATE_OTHER_INFO = 'UPDATE_OTHER_INFO';
export const TOGGLE_LIFE_CIRCUMSTANCES = 'TOGGLE_LIFE_CIRCUMSTANCES';
export const UPDATE_TEAS = 'UPDATE_TEAS';

// PT Requirements Information Actions
export const UPDATE_PT_REQUIREMENTS_INFO = 'UPDATE_PT_REQUIREMENTS_INFO';


// Auth Actions - Okta and API Actions
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

// Auth Actions - AWS
export const CREDENTIALS_REQUEST = 'CREDENTIALS_REQUEST';
export const CREDENTIALS_SUCCESS = 'CREDENTIALS_SUCCESS';
export const CREDENTIALS_FAILURE = 'CREDENTIALS_FAILURE';

// Auth Actions - UI
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';


// API Actions
export const FETCH_PERIODS_REQUEST = 'PERIODS_REQUEST';
export const FETCH_PERIODS_SUCCESS = 'PERIODS_SUCCESS';
export const FETCH_PERIODS_FAILURE = 'PERIODS_FAILURE';
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CREATE_APPLICATION_REQUEST = 'CREATE_APPLICATION_REQUEST';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_FAILURE = 'CREATE_APPLICATION_FAILURE';
export const FETCH_APPLICATION_REQUEST = 'FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE = 'FETCH_APPLICATION_FAILURE';
export const UPDATE_APPLICATION_REQUEST = 'UPDATE_APPLICATION_REQUEST';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAILURE = 'UPDATE_APPLICATION_FAILURE';
export const UPDATE_APPLICATION_STATUS_REQUEST = 'UPDATE_APPLICATION_STATUS_REQUEST';
export const UPDATE_APPLICATION_STATUS_SUCCESS = 'UPDATE_APPLICATION_STATUS_SUCCESS';
export const UPDATE_APPLICATION_STATUS_FAILURE = 'UPDATE_APPLICATION_STATUS_FAILURE';
export const SUBMIT_APPLICATION_REQUEST = 'SUBMIT_APPLICATION_REQUEST';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export const SUBMIT_APPLICATION_FAILURE = 'SUBMIT_APPLICATION_FAILURE';
export const DELETE_APPLICATION_REQUEST = 'DELETE_APPLICATION_REQUEST';
export const DELETE_APPLICATION_SUCCESS = 'DELETE_APPLICATION_SUCCESS';
export const DELETE_APPLICATION_FAILURE = 'DELETE_APPLICATION_FAILURE';
export const APP_ALREADY_SET = 'APP_ALREADY_SET';